// Mirrors api/src/lib/policy.ts. Values come from
// phase-1/client-decisions.md (Recommendation column).
// Change here AND in the API policy when the client confirms.

import type { Role } from "../api/types";

export const CONFIG = {
  adminModuleAccess: ["management"] as Role[],
  evictionOverride: ["management"] as Role[],
  evictionLift: ["management"] as Role[],
  maintenanceBuildingsLimited: false,
};

export function canAccessAdmin(role: Role): boolean {
  return CONFIG.adminModuleAccess.includes(role);
}

export function canOverrideEviction(role: Role): boolean {
  return CONFIG.evictionOverride.includes(role);
}

export function canLiftEviction(role: Role): boolean {
  return CONFIG.evictionLift.includes(role);
}
